/** LocalStorage keys. Versioned so a future schema change can migrate cleanly. */
export const STORAGE_KEY = {
  CONFIG: 'toyama.rcu-config.v1',
  TECHNICIAN: 'toyama.technician.v1',
  /** Broker address and credentials for the technician console's link. */
  LINK: 'toyama.rcu-link.v1',
} as const;

/** Bumped whenever the persisted configuration shape changes. */
export const SCHEMA_VERSION = 1;
